import { tv } from '@/common/theme/tv.config';

export const styles = tv({
  slots: {
    cardWrapper:
      'perspective-[100rem] transform-style-[preserve-3d] relative h-[227px] w-[360px]',

    buttonWrapper:
      'absolute bottom-[-60px] left-1/2 -translate-x-1/2 transform',
  },
  variants: {},
})();
